import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, useLocation } from 'react-router-dom';
import GraphItems from './GraphItems';
import StreamGraphItems from './StreamGraphItems';
import ProbConsScatterItems from './ProbConsScatterItems';
import SimResultItems from './SimResultItems';
import RBSItems from './RBSItems';
import PromaItems from './PromaHierarchy';
import MapItems from './MapItems';
import { defaultViews } from '../views/views';
import GoogleSheetAssessmentsLoader from '../google/GSheetAssessmentLoader';
import GoogleSheetSimResultsLoader from '../google/GSheetRiskSimLoader';
import GoogleCalendarLoader from '../google/GoogleCalendarLoader';
import GoogleSheetPROMALoader from '../google/GSheetPROMALoader';
import GoogleSheetRBSLoader from '../google/GSheetRBSLoader';
import GoogleSheetMaploader from '../google/GSheetMaploader';
import GPhotoLoader from '../google/GPhotoLoader';
import { ItemContext } from '../App';
import GoogleDriveJSONLoader from '../google/GDriveJSONLoader';
import GoogleSheetPanoramaHotspotLoader from '../google/GSheetPanoramaInfoLoader';
import GanttItems from './PromaGantt';
import GoogleSheetGeneralLoader from '../google/GSheetGeneralLoader';
import { PromaItemType } from './itemDefinitions';
import DesignStatusItems from './DesignStatusItems';
import GoogleSheetPROMAWorkForceLoader from '../google/GSheetPROMAWorkforceLoader';
import ResourcingStreamGraphItems from './ResourcingStreamGraph';

const ChangeRoute = () => {
  const { setCurrentView } = useContext(ItemContext);
  const usePageViews = () => {
    const location = useLocation();
    useEffect(() => {
      if (location.pathname === '/') {
        setCurrentView(defaultViews[1]);
      } else if (location.pathname === '/simulations') {
        setCurrentView(defaultViews[2]);
      } else if (location.pathname === '/calendar') {
        setCurrentView(defaultViews[3]);
      } else if (location.pathname === '/graph') {
        setCurrentView(defaultViews[4]);
      } else if (location.pathname === '/rbs' || location.pathname === '/rbs2') {
        setCurrentView(defaultViews[5]);
      } else if (location.pathname === '/proma') {
        setCurrentView(defaultViews[6]);
      } else if (location.pathname === '/map' || location.pathname === '/blockmap') {
        setCurrentView(defaultViews[7]);
      } else if (location.pathname === '/design') {
        setCurrentView(defaultViews[8]);
      } else if (location.pathname === '/gantt') {
        setCurrentView(defaultViews[9]);
      } else if (location.pathname === '/workforce') {
        setCurrentView(defaultViews[10]);
      }
    }, [location]);
  };
  usePageViews();
  return null;
};

const MapLoaders = () => {
  return (
    <>
      <GoogleSheetPanoramaHotspotLoader sheetId="1xeCMexxck2YC4Np4COXqSI_0LDxINeK629wBbKoLi0U" />
    </>
  );
};

const ViewRouter = () => {
  const { currentView, itemProps, filterDict } = useContext(ItemContext);

  const { showItems } = currentView;
  const showTabs = currentView.tabs;

  return (
    <div className={currentView.absoluteFilterPosition ? 'content_layer_2' : ''}>
      <Router>
        <ChangeRoute />
        <Switch>
          <Route path="/">
            <MapItems
              showItems={showItems}
              filterDict={filterDict}
              itemProps={itemProps}
              defaultLayers={['Virtuaalimalli']}
              zoom={14}
            />
          </Route>
        </Switch>
      </Router>
    </div>
  );
};

export default ViewRouter;
